import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #17: Particle physics is hard",
  "description": "",
  "published": "2016-08-04T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-17-particle-physics-is-hard/swizec/6903"],
  "categories": "Front End, Livecoding, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Shorter than 500 words. With pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`Did you know particle physics was hard? I had no idea.`}</p>
    <p>{`I wanted to inject interestingness into the animated particles experiment. Take a random animation of a bunch of particles and turn it into a simulation of the forces between charged particles. It would look so totally cool!`}</p>
    <p>{`It did not go so well.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/dERre"
        }}></a></p>
    </blockquote>
    <p>{`Sure, I had `}<em parentName="p">{`some`}</em>{` idea that deriving electrostatic force equations from scratch was hard, but it’s 2016, we know this stuff! Teachers show it to us in middle school and high school and college too. How hard can it be?`}</p>
    <p>{`Pretty hard.`}</p>
    <p>{`The Wikipedia article on `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Electric_field"
      }}>{`electric fields`}</a>{` did not help. It has a bunch of equations, but none that seem useful. Or maybe my reading comprehension is bad when I’m on camera.`}</p>
    <p>{`The article does link to `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Coulomb%27s_law"
      }}>{`Coulomb’s law`}</a>{`, which looks a lot like the equation a theoretical physicist explained in the live chatroom. I think his name was zimaguy, but livecoding.tv won’t let me scroll back in the chatroom to check.`}</p>
    <p>{`How cool is it that we had a real life theoretical physicist on the live stream? Wow.`}</p>
    <p>{`The formula he gave says that force between a static charge and a particle is equal to `}<inlineCode parentName="p">{`1/r^2`}</inlineCode>{`, where `}<inlineCode parentName="p">{`r`}</inlineCode>{` is the euclidian distance between two points. We get it using Pythagorus’ formula:`}</p>
    <pre><code parentName="pre" {...{}}>{`dx = x1 - x2
dy = y1 - y2
r^2 = dx^2 + dy^2
`}</code></pre>
    <p>{`Remember middle school maths and asking the professor `}<em parentName="p">{`“But miiiissss when will I ever need this in real life?”`}</em>{`. When you’re coding cool stuff, that’s when.`}</p>
    <p>{`The best part of this formula is that we use `}<inlineCode parentName="p">{`r^2`}</inlineCode>{` and don’t need a square root. Roots are expensive, multiplication is cheap.`}</p>
    <p>{`The tricky part is turning this scalar into a vector. The debate with zimaguy went back and forth and I had to settle for a rough approximation. It only understands 4 directions (Up/Down, Left/Right) and misses all of the beauty of vector mathematics, but the end result looks good enough.`}</p>
    <p>{`We use the calculation for each static charge. Like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// reducer that moves each particle

p.x += vx * multiplier;
p.y += vy * multiplier;

state.charges.forEach((charge) => {
  let dx = p.x - charge.x,
    dy = p.y - charge.y,
    r2 = dx * dx + dy * dy,
    rX = (dx < 0 ? -(1 / r2) : 1 / r2) * charge.strength,
    rY = (dy < 0 ? -(1 / r2) : 1 / r2) * charge.strength;

  p.x += rX;
  p.y += rY;
});
`}</code></pre>
    <p>{`First we calculate each particle’s new position, then go through the list of charges, and calculate electric force effects. Movement has to happen first, otherwise the charges have a delayed effect that looks weird.`}</p>
    <p>{`And voila.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/dERre"
        }}></a></p>
    </blockquote>
    <p>{`This week I want to play with an interesting dataset of some sort. Something that takes a lot of moving parts to showcase … ideas?`}</p>
    <p>{`PS: the edited and improved versions of these videos are becoming a video course. Readers of the engineer package of `}<a parentName="p" {...{
        "href": "http://swizec.com/reactd3js/"
      }}>{`React+d3js ES6`}</a>{` get the video course for free when it’s ready.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      